import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../../../utils/contexts/UserContext";
import { hasPermission } from "../../../utils/permissions";

// Route-level permission guard. Wrap a group of <Route>s so pages don't each
// re-implement the redirect; renders nothing the user isn't allowed to see.
export default function RequirePermission({ permission, children }) {
  const { user } = useContext(UserContext);

  if (!hasPermission(user, permission)) return <Navigate to="/" replace />;

  return children ?? <Outlet />;
}
